"use client";

import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import styles from "../../styles/Testimonialsslider.module.scss";

// ─── Types ────────────────────────────────────────────────────────────────────

interface Testimonial {
  quote: string;
  name: string;
  designation: string;
  src: string;
}

// ─── Data ─────────────────────────────────────────────────────────────────────

const TESTIMONIALS: Testimonial[] = [
  // ── Company Incorporation ───────────────────────────────────────────────
  {
    quote:
      "I had the idea but no clarity on how to start legally. Their team made the entire process simple and quick. Now I can focus on growing my business.",
    name: "Aarav Sharma",
    designation: "Founder, E-commerce Business",
    src: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&q=80&auto=format&fit=crop",
  },
  {
    quote:
      "I was running my business informally for a long time. Getting it registered gave me confidence and made my brand look more professional.",
    name: "Sneha Bansal",
    designation: "Founder, Clothing Brand",
    src: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&q=80&auto=format&fit=crop",
  },
  {
    quote:
      "I thought this process would take months, but it was completed much faster than I expected. Very smooth experience.",
    name: "Rohit Agarwal",
    designation: "Owner, Trading Business",
    src: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&q=80&auto=format&fit=crop",
  },
  // ── Website Development ─────────────────────────────────────────────────
  {
    quote:
      "I didn't realize how important a website was until I saw the results. It gave my business a completely new identity.",
    name: "Neha Gupta",
    designation: "Founder, Home Décor Brand",
    src: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&q=80&auto=format&fit=crop",
  },
  {
    quote:
      "Earlier, I was handling everything manually. The website made my business look more professional and helped me get better responses.",
    name: "Aditya Jain",
    designation: "Owner, Fitness Equipment Business",
    src: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&q=80&auto=format&fit=crop",
  },
  {
    quote:
      "People can now find my business easily online. It has really helped me get new clients without much effort.",
    name: "Kavita Sharma",
    designation: "Owner, Salon & Beauty Services",
    src: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&q=80&auto=format&fit=crop",
  },
  // ── Certifications ──────────────────────────────────────────────────────
  {
    quote:
      "I had heard about MSME benefits but didn't know how to apply. They made it very easy and helped me get it without any hassle.",
    name: "Rajesh Verma",
    designation: "Owner, Manufacturing Unit",
    src: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&q=80&auto=format&fit=crop",
  },
  {
    quote:
      "I didn't know this certification was so important. They helped me get it easily and explained all the benefits clearly.",
    name: "Deepak Yadav",
    designation: "Owner, Small Manufacturing Unit",
    src: "https://images.unsplash.com/photo-1618077360395-f3068be8e001?w=400&q=80&auto=format&fit=crop",
  },
  {
    quote:
      "I thought it would be complicated, but they made it very simple. Everything was handled professionally.",
    name: "Pankaj Singh",
    designation: "Service Provider — ISO Certified",
    src: "https://images.unsplash.com/photo-1531891437562-4301cf35b7e4?w=400&q=80&auto=format&fit=crop",
  },
  {
    quote:
      "I was worried about making mistakes, but they handled everything perfectly. Got my license without any issues.",
    name: "Meena Kumari",
    designation: "Owner, Food Business — FSSAI Licensed",
    src: "https://images.unsplash.com/photo-1598550874175-4d0ef436c909?w=400&q=80&auto=format&fit=crop",
  },
  // ── Government Funds ────────────────────────────────────────────────────
  {
    quote:
      "I had the plan but no funding support. Their team guided me properly and made sure everything was done right. The approval changed my business.",
    name: "Imran Khan",
    designation: "Owner, Food Processing — PMEGP ₹25L",
    src: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&q=80&auto=format&fit=crop",
  },
  {
    quote:
      "I was confused between different schemes. They guided me properly and made the process very easy.",
    name: "Suresh Patel",
    designation: "Owner, Retail Business — Mudra Loan ₹12L",
    src: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&q=80&auto=format&fit=crop",
  },
  {
    quote:
      "I thought getting a loan without collateral was not possible. Their support made it happen.",
    name: "Anil Kumar",
    designation: "Workshop Owner — CGTMSE Loan ₹18L",
    src: "https://images.unsplash.com/photo-1590086783191-a0694f7d1e6e?w=400&q=80&auto=format&fit=crop",
  },
  {
    quote:
      "I had plans but no financial support. Their team made sure everything was handled properly. Very reliable service.",
    name: "Farhan Ali",
    designation: "Owner, Packaging Business — Stand-Up India ₹30L",
    src: "https://images.unsplash.com/photo-1566492031773-4f4e44671857?w=400&q=80&auto=format&fit=crop",
  },
  // ── Grants & Venture Capital ────────────────────────────────────────────
  {
    quote:
      "I didn't think I could get funding without collateral. Their guidance helped me secure a grant and start my journey.",
    name: "Pooja Mehta",
    designation: "Founder, Sustainable Startup — Grant ₹10L",
    src: "https://images.unsplash.com/photo-1551836022-deb4988cc6c0?w=400&q=80&auto=format&fit=crop",
  },
  {
    quote:
      "Raising funds felt impossible before. They helped me present my idea properly and connected me with the right people.",
    name: "Karan Malhotra",
    designation: "Founder, Tech Startup — VC Funding ₹1.2 Cr",
    src: "https://images.unsplash.com/photo-1504257432389-52343af06ae3?w=400&q=80&auto=format&fit=crop",
  },
  {
    quote:
      "I didn't know such funding options even existed. They supported me at every step and made it possible.",
    name: "Sunita Devi",
    designation: "Owner, Handicraft Business — NVFC ₹15L",
    src: "https://images.unsplash.com/photo-1594744803329-e58b31de8bf5?w=400&q=80&auto=format&fit=crop",
  },
  // ── Digital Marketing ───────────────────────────────────────────────────
  {
    quote:
      "I was spending on ads but not getting results. They changed the strategy and I started seeing real sales. It made a huge difference.",
    name: "Ritu Arora",
    designation: "Founder, Fashion Brand — Digital Marketing",
    src: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400&q=80&auto=format&fit=crop",
  },
];

const AUTOPLAY_DELAY = 5000;

// ─── GLSL Shaders ─────────────────────────────────────────────────────────────

const VERTEX_SOURCE = `
  attribute vec2 position;
  varying vec2 vUv;
  void main() {
    vUv = position * 0.9 + 0.5;
    gl_Position = vec4(position, 0.0, 1.0);
  }
`;

const FRAGMENT_SOURCE = `
  precision mediump float;
  uniform float iTime;
  uniform vec2 iResolution;
  varying vec2 vUv;

  float random(vec2 uv) {
    return fract(sin(dot(uv.xy, vec2(12.9898, 78.233))) * 43758.5453123);
  }
  float noise(vec2 uv) {
    vec2 i = floor(uv);
    vec2 f = fract(uv);
    float a = random(i);
    float b = random(i + vec2(1., 0.));
    float c = random(i + vec2(0., 1.));
    float d = random(i + vec2(1., 1.));
    vec2 u = f * f * (3.0 - 2.0 * f);
    return mix(mix(a, b, u.x), mix(c, d, u.x), u.y);
  }
  vec3 palette(float t) {
    vec3 a = vec3(0.85, 0.82, 0.78); // base light tone
    vec3 b = vec3(0.25, 0.20, 0.15); // soft variation
    vec3 c = vec3(0.80, 0.60, 0.40);
    vec3 d = vec3(0.00, 0.10, 0.20);

    return a + b * cos(6.28318 * (c * t + d));
}
  #define OCTAVES 6
  float fbm(vec2 uv) {
    float lacunarity = 3.0;
    float gain = 0.5;
    float amplitude = 0.5;
    float frequency = 1.0;
    float result = 0.0;
    for (int i = 0; i < OCTAVES; i++) {
      result += amplitude * noise(frequency * uv);
      frequency *= lacunarity;
      amplitude *= gain;
    }
    return result;
  }
  void main() {
    vec2 fragCoord = vUv * iResolution;
    vec2 uv = (fragCoord - iResolution * 0.5) / iResolution.y * 10.0;
    float uvt = sin(length(uv) - iTime);
    vec2 uv2 = uv * fbm(uv) * uvt;
    vec3 col = palette(fbm(uv2));
    gl_FragColor = vec4(col, 1.0);
  }
`;

// ─── WebGL helpers ────────────────────────────────────────────────────────────

function createShader(gl: WebGLRenderingContext, type: number, src: string) {
  const shader = gl.createShader(type)!;
  gl.shaderSource(shader, src);
  gl.compileShader(shader);
  if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS))
    throw new Error(gl.getShaderInfoLog(shader) ?? "shader error");
  return shader;
}

function createProgram(
  gl: WebGLRenderingContext,
  vsrc: string,
  fsrc: string
): WebGLProgram {
  const prog = gl.createProgram()!;
  gl.attachShader(prog, createShader(gl, gl.VERTEX_SHADER, vsrc));
  gl.attachShader(prog, createShader(gl, gl.FRAGMENT_SHADER, fsrc));
  gl.linkProgram(prog);
  if (!gl.getProgramParameter(prog, gl.LINK_STATUS))
    throw new Error(gl.getProgramInfoLog(prog) ?? "program error");
  return prog;
}

// ─── GSAP-like spring animator (no external dep) ─────────────────────────────

// ─── Main component ───────────────────────────────────────────────────────────

export default function TestimonialsSlider() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const imageContainerRef = useRef<HTMLDivElement>(null);
  const imgRefs = useRef<(HTMLImageElement | null)[]>([]);

  // Text-node refs
  const nameRef = useRef<HTMLHeadingElement>(null);
  const desigRef = useRef<HTMLParagraphElement>(null);
  const quoteRef = useRef<HTMLParagraphElement>(null);

  const [activeIndex, setActiveIndex] = useState(0);
  const activeIndexRef = useRef(0);
  const autoplayRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const userPausedRef = useRef(false);

  // ── Helpers ──────────────────────────────────────────────────────────────

  const calculateGap = useCallback((width: number) => {
    const minWidth = 1024,
      maxWidth = 1456,
      minGap = 60,
      maxGap = 86;
    if (width <= minWidth) return minGap;
    if (width >= maxWidth)
      return Math.max(minGap, maxGap + 0.06018 * (width - maxWidth));
    return minGap + (maxGap - minGap) * ((width - minWidth) / (maxWidth - minWidth));
  }, []);

  // Simple CSS-transition based image positioner (no GSAP dependency)
  const positionImages = useCallback(
    (newIndex: number) => {
      const container = imageContainerRef.current;
      if (!container) return;
      const gap = calculateGap(container.offsetWidth);
      const maxStickUp = gap * 0.8;
      const total = TESTIMONIALS.length;

      imgRefs.current.forEach((img, index) => {
        if (!img) return;
        const offset = ((index - newIndex) % total + total) % total;
        const zIndex = total - Math.abs(offset > total / 2 ? offset - total : offset);

        let translateX = "0%";
        let translateY = "0%";
        let rotateY = "0deg";
        let scale = "1";

        if (offset === 0) {
          translateX = "0%";
          translateY = "0%";
          rotateY = "0deg";
          scale = "1";
        } else if (offset === 1 || offset === total - 2) {
          translateX = "20%";
          translateY = `-${(maxStickUp / img.offsetHeight) * 100}%`;
          rotateY = "-15deg";
          scale = "0.85";
        } else {
          translateX = "-20%";
          translateY = `-${(maxStickUp / img.offsetHeight) * 100}%`;
          rotateY = "15deg";
          scale = "0.85";
        }

        img.style.transition =
          "transform 0.8s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.5s ease, z-index 0s";
        img.style.zIndex = String(zIndex);
        img.style.opacity = "1";
        img.style.transform = `translateX(${translateX}) translateY(${translateY}) rotateY(${rotateY}) scale(${scale})`;
      });
    },
    [calculateGap]
  );

  // Animate text out → update → animate in
  const animateText = useCallback((newIndex: number) => {
    const els = [nameRef.current, desigRef.current].filter(Boolean) as HTMLElement[];
    const quote = quoteRef.current;

    // Fade out
    els.forEach((el) => {
      el.style.transition = "opacity 0.25s ease, transform 0.25s ease";
      el.style.opacity = "0";
      el.style.transform = "translateY(-16px)";
    });
    if (quote) {
      quote.style.transition = "opacity 0.25s ease, transform 0.25s ease";
      quote.style.opacity = "0";
      quote.style.transform = "translateY(-16px)";
    }

    setTimeout(() => {
      // Update text
      if (nameRef.current)
        nameRef.current.textContent = TESTIMONIALS[newIndex].name;
      if (desigRef.current)
        desigRef.current.textContent = TESTIMONIALS[newIndex].designation;

      if (quote) {
        // Word-by-word span injection
        quote.innerHTML = TESTIMONIALS[newIndex].quote
          .split(" ")
          .map((w) => `<span class="word" style="opacity:0;display:inline-block">${w}</span>`)
          .join(" ");
      }

      // Fade in name / designation
      els.forEach((el) => {
        el.style.opacity = "1";
        el.style.transform = "translateY(0)";
      });

      // Stagger words
      if (quote) {
        quote.style.opacity = "1";
        quote.style.transform = "translateY(0)";
        const words = quote.querySelectorAll<HTMLSpanElement>(".word");
        words.forEach((word, i) => {
          setTimeout(() => {
            word.style.transition = "opacity 0.2s ease, transform 0.2s ease";
            word.style.opacity = "1";
            word.style.transform = "translateY(0)";
          }, i * 20);
        });
      }
    }, 280);
  }, []);

  const goTo = useCallback(
    (direction: 1 | -1 | 0) => {
      const total = TESTIMONIALS.length;
      const prev = activeIndexRef.current;
      const next =
        direction === 0 ? prev : (prev + direction + total) % total;
      activeIndexRef.current = next;
      setActiveIndex(next);
      positionImages(next);
      animateText(next);
    },
    [positionImages, animateText]
  );

  const handleNext = useCallback(() => {
    goTo(1);
  }, [goTo]);

  const handlePrev = useCallback(() => {
    goTo(-1);
  }, [goTo]);

  // Stop autoplay on manual interaction
  const stopAutoplay = useCallback(() => {
    userPausedRef.current = true;
    if (autoplayRef.current) clearInterval(autoplayRef.current);
  }, []);

  // ── Initial render + resize ───────────────────────────────────────────────

  useLayoutEffect(() => {
    positionImages(0);
    animateText(0);
  }, [positionImages, animateText]);

  useEffect(() => {
    const onResize = () => positionImages(activeIndexRef.current);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [positionImages]);

  // ── Autoplay ─────────────────────────────────────────────────────────────

  useEffect(() => {
    autoplayRef.current = setInterval(() => {
      if (!userPausedRef.current) {
        const total = TESTIMONIALS.length;
        const next = (activeIndexRef.current + 1) % total;
        activeIndexRef.current = next;
        setActiveIndex(next);
        positionImages(next);
        animateText(next);
      }
    }, AUTOPLAY_DELAY);

    return () => {
      if (autoplayRef.current) clearInterval(autoplayRef.current);
    };
  }, [positionImages, animateText]);

  // ── WebGL background ──────────────────────────────────────────────────────

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const gl = canvas.getContext("webgl");
    if (!gl) return;

    let raf: number;

    try {
      const prog = createProgram(gl, VERTEX_SOURCE, FRAGMENT_SOURCE);

      const buf = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, buf);
      gl.bufferData(
        gl.ARRAY_BUFFER,
        new Float32Array([-1, -1, 1, -1, -1, 1, -1, 1, 1, -1, 1, 1]),
        gl.STATIC_DRAW
      );

      const posLoc = gl.getAttribLocation(prog, "position");
      const iTimeLoc = gl.getUniformLocation(prog, "iTime");
      const iResLoc = gl.getUniformLocation(prog, "iResolution");

      const resize = () => {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
        gl.viewport(0, 0, canvas.width, canvas.height);
      };
      window.addEventListener("resize", resize);
      resize();

      const render = (now: number) => {
        gl.useProgram(prog);
        gl.bindBuffer(gl.ARRAY_BUFFER, buf);
        gl.enableVertexAttribArray(posLoc);
        gl.vertexAttribPointer(posLoc, 2, gl.FLOAT, false, 0, 0);
        gl.uniform1f(iTimeLoc, now * 0.001);
        gl.uniform2f(iResLoc, canvas.width, canvas.height);
        gl.drawArrays(gl.TRIANGLES, 0, 6);
        raf = requestAnimationFrame(render);
      };
      raf = requestAnimationFrame(render);

      return () => {
        cancelAnimationFrame(raf);
        window.removeEventListener("resize", resize);
      };
    } catch (e) {
      console.error("WebGL init failed", e);
    }
  }, []);

  // ─── Render ────────────────────────────────────────────────────────────────

  return (
    <div className={styles.pageShell}>
      {/* Animated WebGL canvas */}
      <canvas ref={canvasRef} className={styles.glcanvas} />

      {/* Glassmorphic card */}
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.grid}>
            {/* ── Image stack ── */}
            <div
              className={styles.imageContainer}
              ref={imageContainerRef}
            >
              {TESTIMONIALS.map((t, i) => (
                // eslint-disable-next-line @next/next/no-img-element
                <img
                  key={t.name}
                  ref={(el) => {
                    imgRefs.current[i] = el;
                  }}
                  src={t.src}
                  alt={t.name}
                  data-index={i}
                  className={styles.testimonialImage}
                />
              ))}
            </div>

            {/* ── Text content ── */}
            <div className={styles.content}>
              <div>
                <h3 ref={nameRef} className={styles.name}>
                  {TESTIMONIALS[0].name}
                </h3>
                <p ref={desigRef} className={styles.designation}>
                  {TESTIMONIALS[0].designation}
                </p>
                <p ref={quoteRef} className={styles.quoteText} />
              </div>

              {/* Arrows */}
              <div className={styles.arrowButtons}>
                <button
                  className={`${styles.arrowButton} ${styles.prev}`}
                  onClick={() => {
                    stopAutoplay();
                    handlePrev();
                  }}
                  aria-label="Previous testimonial"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
                  </svg>
                </button>
                <button
                  className={`${styles.arrowButton} ${styles.next}`}
                  onClick={() => {
                    stopAutoplay();
                    handleNext();
                  }}
                  aria-label="Next testimonial"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
                  </svg>
                </button>
              </div>

              {/* Progress dots */}
              <div className={styles.dots}>
                {TESTIMONIALS.map((_, i) => (
                  <button
                    key={i}
                    className={`${styles.dot} ${i === activeIndex ? styles.active : ""
                      }`}
                    onClick={() => {
                      stopAutoplay();
                      activeIndexRef.current = i;
                      setActiveIndex(i);
                      positionImages(i);
                      animateText(i);
                    }}
                    aria-label={`Go to testimonial ${i + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}